module.exports = __webpack_public_path__ + "src/img/uploadIcon.9d23b033.svg";